import { render } from "./IconManual.vue?vue&type=template&id=7216461a"
const script = {}

import exportComponent from "/var/www/metiznew/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__